module.exports = __webpack_public_path__ + "img/header_bg.b9d06c83.svg";